import jwtService from './jwtService'

export default jwtService
